import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues, change } from 'redux-form';

import { Filter, Main } from 'Containers/';
import { EDIT_SERVED_ITEM_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage } from 'Components/';
import { EditServedItemFieldEnum as Fields } from 'Common/FieldEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { NutritionCodeEnum } from 'Common/Constants/Enumeration/NutritionCodeEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';

import {
  getInitialData,
  writeItem,
  getAlternateItems,
  clearError,
} from '../state/editserveditem/actions';
import { EditServedItemForm } from '../components/EditServedItemForm';

class EditServedItemContainer extends Component {
  static path = '/serveditemsetup/:itemId';

  getRootUrl = () => {
    return this.props.match.url.replace(
      /\/serveditemsetup\/.*/gi,
      '/serveditemsetup/'
    );
  };

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        formName: EDIT_SERVED_ITEM_FORM_NAME,
        shown: true,
        isReadOnly: this.props.isReadOnly,
      },
    };
  };

  componentDidMount() {
    const { itemId } = this.props.match.params;
    this.props.getInitialData(itemId);
  }

  componentDidUpdate(prevProps) {
    const {
      getAlternateItems,
      formValues,
      fetchError,
      clearError,
      history,
      newItemId,
    } = this.props;
    if (
      formValues &&
      formValues[Fields.NutritionCode] === NutritionCodeEnum.FederalType1Meal &&
      (!prevProps.formValues ||
        prevProps.formValues[Fields.NutritionCode] !==
          formValues[Fields.NutritionCode])
    ) {
      getAlternateItems(formValues[Fields.ItemIdLetter]);
    }

    if (fetchError) {
      createToast(toastType.error, 'Error', fetchError);
      clearError();
    }

    if (newItemId && newItemId !== formValues[Fields.ItemId]) {
      history.push(`${this.getRootUrl()}${newItemId}`);
    }
  }

  handleSubmit = async values => {
    await this.props.writeItem(values);
    this.redirectMe();
  };

  redirectMe = () => {
    this.props.history.push(this.getRootUrl());
  };

  render() {
    const {
      formValues,
      itemData,
      nutritionCodes,
      itemCategories,
      alternateItems,
      match,
      change,
      grades,
      isReadOnly,
    } = this.props;
    const { itemId } = match.params;

    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter
          title={itemId === '0' ? 'New Served Item' : 'Edit Served Item'}
        />
        <Main {...this.getMainProps()}>
          <EditServedItemForm
            Id={itemId}
            formValues={formValues}
            initialValues={itemData}
            nutritionCodes={nutritionCodes}
            itemCategories={itemCategories}
            alternateItems={alternateItems}
            change={change}
            onSubmit={this.handleSubmit}
            grades={grades}
            isReadOnly={isReadOnly}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { EditServedItem } = state.ServedItemSetupState;
  ownProps.setPageLevelDirty(getIsDirty(EDIT_SERVED_ITEM_FORM_NAME)(state));
  return {
    formValues: getFormValues(EDIT_SERVED_ITEM_FORM_NAME)(state),
    loading: EditServedItem.fetching,
    itemData: EditServedItem.itemData,
    nutritionCodes: EditServedItem.nutritionCodes,
    itemCategories: EditServedItem.itemCategories,
    alternateItems: EditServedItem.alternateItems,
    grades: EditServedItem.grades,
    fetchError: EditServedItem.fetchError,
    newItemId: EditServedItem.newItemId,
  };
};

export const EditServedItem = withRouter(
  connect(mapStateToProps, {
    getInitialData,
    writeItem,
    change,
    getAlternateItems,
    clearError,
  })(EditServedItemContainer)
);



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/subpages/EditServedItem.js